import React from 'react';
import { useTranslation } from 'react-i18next';
import { Clock3, FolderKanban, TrendingDown, BrainCircuit, Rocket } from 'lucide-react';
import { Container, SectionHeading, GlassCard, IconBadge } from './shared';

const ICONS = [Clock3, FolderKanban, TrendingDown, BrainCircuit, Rocket];
const CARD_KEYS = ['hoursSaved', 'onePlace', 'lowerCosts', 'knowledgeStays', 'adaptFaster'];

const BenefitsSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="benefits" className="relative py-24 sm:py-32">
      <Container>
        <SectionHeading eyebrow={t('landing.benefits.eyebrow')} title={t('landing.benefits.title')} />

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {CARD_KEYS.map((key, i) => {
            const Icon = ICONS[i];
            return (
              <GlassCard key={key} index={i}>
                <IconBadge>
                  <Icon className="h-6 w-6 text-white" />
                </IconBadge>
                <h3 className="mb-3 text-xl font-semibold text-white">
                  {t(`landing.benefits.cards.${key}.title`)}
                </h3>
                <p className="leading-relaxed text-brand-muted">
                  {t(`landing.benefits.cards.${key}.description`)}
                </p>
              </GlassCard>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default BenefitsSection;
